export const selectClientCallbacksState = state => state.clientCallbacks || {}
export const selectClientCallbacksItems = state => (state.clientCallbacks?.items) || []
export const selectClientCallbacksLoading = state => state.clientCallbacks?.loading
export const selectClientCallbacksError = state => state.clientCallbacks?.error
export const selectClientCallbacksPagination = state => state.clientCallbacks?.pagination || { currentPage: 1, lastPage: 1, perPage: 20, total: 0 }
export const selectClientCallbacksView = state => state.clientCallbacks?.view || 'upcoming'
export const selectClientCallbacksDeletingId = state => state.clientCallbacks?.deletingId
export const selectClientCallbacksConfirmDeleteId = state => state.clientCallbacks?.confirmDeleteId
